
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

type LiveStatus = '完売御礼！' | 'チケット販売中' | 'Comming Soon !';

type UpcomingShow = {
  id: number;
  dateLabel: string; // 例: "02.21 sat 2026" / "Comming Soon !"
  dateISO?: string; // 例: "2026-02-21"
  title1?: string;
  title2?: string;
  venue?: string;
  area?: string; // 例: "東京・渋谷"
  openStart?: string; // 例: "open/start 18:00/19:00"
  price?: string;
  status: LiveStatus;
};

function isPastShow(dateISO?: string) {
  if (!dateISO) return false;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateISO);
  if (!m) return false;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const showDate = new Date(y, mo - 1, d, 23, 59, 59, 999);
  const now = new Date();
  return now.getTime() > showDate.getTime();
}

export default function UpcomingLiveSection() {
  const upcomingShows: UpcomingShow[] = [
    {
      id: 1,
      dateLabel: '02.21 sat 2026',
      dateISO: '2026-02-21',
      title1: '2026 Acoustic One-Man',
      title2: '静かな決意、再始動。',
      venue: 'Cafe & Gallery ホシノテレカ',
      area: '東京・渋谷',
      openStart: 'open/start 18:00/19:00',
      price: '前売り ¥2,500 / 当日 ¥3,500 +1 drink ¥600',
      status: '完売御礼！'
    },
    {
      id: 2,
      dateLabel: 'Comming Soon !',
      status: 'Comming Soon !'
    },
    {
      id: 3,
      dateLabel: 'Comming Soon !',
      status: 'Comming Soon !'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Live Schedule</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            ライブスケジュールをお知らせします。
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
            {upcomingShows.map((show) => {
              const isPast = isPastShow(show.dateISO);
              const isSoldOut = show.status === '完売御礼！';
              const isComingSoon = show.status === 'Comming Soon !';
              const disableTicket = isPast || isSoldOut || isComingSoon;

              const badgeClass =
                show.status === '完売御礼！'
                  ? 'bg-pink-100 text-pink-800'
                  : show.status === 'チケット販売中'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-200 text-gray-700';

              return (
              <div key={show.id} className="bg-gray-50 rounded-2xl p-6 md:p-8 hover:shadow-lg transition-shadow duration-300">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-center">
                  <div className="md:col-span-1">
                    <div className="text-center md:text-left">
                      <div className="text-xl md:text-2xl font-bold text-black mb-1">
                        {show.dateLabel}
                      </div>
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    {show.title1 && <h3 className="text-xl font-bold">{show.title1}</h3>}
                    {show.title2 && <p className="text-gray-700 mt-1">{show.title2}</p>}

                    {(show.venue || show.area || show.openStart || show.price) && (
                      <div className="mt-4 space-y-1 text-gray-600">
                        {show.venue && (
                          <div className="flex items-center">
                            <i className="ri-map-pin-line mr-2"></i>
                            {show.venue}
                          </div>
                        )}
                        {show.area && (
                          <div className="flex items-center">
                            <i className="ri-map-pin-2-line mr-2"></i>
                            {show.area}
                          </div>
                        )}
                        {show.openStart && (
                          <div className="flex items-center">
                            <i className="ri-time-line mr-2"></i>
                            {show.openStart}
                          </div>
                        )}
                        {show.price && (
                          <div className="flex items-center">
                            <i className="ri-ticket-line mr-2"></i>
                            {show.price}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="md:col-span-1 text-center md:text-right">
                    <div className="mb-3">
                      <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${badgeClass}`}>
                        {show.status}
                      </span>
                    </div>
                    <Button
                      size="sm"
                      disabled={disableTicket}
                      className={`w-full md:w-auto ${
                        disableTicket
                          ? 'bg-gray-300 text-gray-600 hover:bg-gray-300'
                          : ''
                      }`}
                    >
                      <i className="ri-ticket-2-line mr-2"></i>
                      チケット購入
                    </Button>
                  </div>
                </div>
              </div>
              );
            })}
          </div>

          <div className="text-center mt-12">
            <Link to="/live">
              <Button variant="outline" size="lg">
                <i className="ri-calendar-event-line mr-2 text-xl"></i>
                すべてのライブ情報を見る
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
